/* eslint-disable react/prop-types */
import { ValidationProvider, useTranslation, useProperty } from '@eti/providers';
import { getUniqueMarketingCarriers } from '../../../utils/carriers';
import validationRules from '../utils/validationRules';
import { getArrivalDate } from '../utils/getArrivalDate';
import { getTravelers } from '../utils/getTravelers';

export const withTravelerDetailsValidationProvider = (WrappedComponent) => (props) => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const isNewCardDesignEnabled = p('IbeClient.AncillaryCardV2.Card.Enabled');

  const validationTexts = {
    required: isNewCardDesignEnabled
      ? t('Product.SelectOneValidation.Message')
      : t('Validation.ProductSection.SelectOption'),
    manulifeDateOfBirthDoNotMatch: t('Products.Manulife.DateOfBirth.DoNotMatch'),
    selectOneOptionRequired: t('Validation.ProductSection.SelectOption'),
    gender: t('Validation.Gender.Required'),
    firstName: t('ValidationMessages.FirstNameIsRequired'),
    lastName: t('ValidationMessages.LastNameIsRequired'),
    invalidCharacters: t('ValidationMessages.InvalidCharacters'),
    dateOfBirth: t('Validation.DateOfBirth.Required'),
    invalidAdultBirthDate: t('Validation.AdultBirthDate.Invalid'),
    invalidChildBirthDate: t('Validation.ChildBirthDate.Invalid'),
    invalidInfantBirthDate: t('Validation.InfantBirthDate.Invalid'),
    invalidInfantBirthDateCheckForFutureDate: t(
      'Validation.InfantBirthDateCheckFutureDate.Invalid',
    ),
    country: t('Validation.Country.Required'),
    phone: t('Validation.Phone.Required'),
    mail: t('Validation.Mail.Required'),
    ryanAirMail: t('TravelerDetails.Form.SpecificValidations.FR.Email.ErrorMessage'),
    emailBlock: t('Validation.EmailBlock.Message'),
    emailConfirmDontMatch: t('Validation.Email.Confirm.DontMatch'),
    travelDocumentIssueCountry: t('Validation.TravelDocumentIssueCountry.Required'),
    travelDocumentType: t('Validation.TravelDocumentType.Required'),
    travelDocumentNumber: t('Validation.TravelDocumentNumber.Required'),
    travelDocumentExpiryDate: t('Validation.TravelDocumentExpiryDate.Required'),
    sameFirstAndLastName: t('Warning.SameFirstNameAndLastName'),
    anotherPassengerWithSameName: t('Warning.AnotherPassengerWithSameName'),
    taxIdRequired: t('ValidationMessages.TaxIdIsRequired'),
    invalidTaxId: t('ValidationMessages.TaxIdIsInvalid'),
  };

  const configuration = {
    adultMinimumAge: p('IbeClient.AdultMinimumAge'),
    allowedCharacters: p('IbeClient.FormValidation.AllowedCharactersInTravelerNames'),
    arrivalDate: getArrivalDate(props),
    enableProductValidation: p(
      'IbeClient.TravelerDetails.OptionalProductsRequireValidation.Enabled',
    ),
    enableRyanAirEmailValidation: p(
      'IbeClient.TravelerDetails.FormFields.EnableSpecificValidation.Carrier.FR',
    ),
    blockedEmailDomains: p('TravelerDetails.EmailField.BlockedDomains'),
    dateFormat: p('IbeClient.TravelerInput.dateInputFormat'),
    marketingCarriers: getUniqueMarketingCarriers(props.bounds),
    taxIdData: {
      taxIdFieldLabel: p('Payment.TaxIdFeature.Label'),
      taxIdFieldFormat: p('Payment.TaxIdFeature.Format'),
    },
    travelers: getTravelers(props),
  };

  return (
    <ValidationProvider rules={validationRules(validationTexts, configuration)}>
      <WrappedComponent {...props} />
    </ValidationProvider>
  );
};
